import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31f6e432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TakeOrderListItem" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "mt-1 flex flex-col" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 flex flex-col"
}
const _hoisted_5 = { class: "flex flex-col mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "История статусов:", -1))
const _hoisted_7 = { class: "flex flex-wrap w-full" }
const _hoisted_8 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "Компания: " + _toDisplayString(_ctx.item.company_name), 1),
      _createElementVNode("span", null, "Номер 1С: " + _toDisplayString(_ctx.item.number_1c || 'Не указан'), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.item.full_address), 1),
      _createElementVNode("span", null, "Период забора: " + _toDisplayString(_ctx.item.period_title || 'Не указан'), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Отправитель: " + _toDisplayString(_ctx.item.sender_full_name), 1),
        _createElementVNode("span", null, "Номер отправителя: " + _toDisplayString(_ctx.item.sender_phone), 1)
      ]),
      (Boolean(_ctx.item.courier))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, "Курьер: " + _toDisplayString(_ctx.item.courier.full_name), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.take_statuses, (status, idx) => {
          return (_openBlock(), _createElementBlock("span", {
            key: `key-${idx}`,
            class: "mt-2"
          }, [
            status
              ? (_openBlock(), _createBlock(_component_cheap, {
                  key: 0,
                  class: _normalizeClass(["small mr-2 w-max", {
                            red: status.key === 'not_assigned',
                            primary: status.key === 'assigned_to_courier',
                            green: status.key === 'cargo_handling',
                            yellow: status.key === 'taken',
                        }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.DispatcherOrderStatusesEnum[status.key]), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_the_button, {
        class: "red text small",
        loading: _ctx.state.is_removing,
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}